module.exports = __webpack_public_path__ + "Proxima Nova Bold.2a20824467f47b7c056b.ttf";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Bold.ttf
// module id = ../../../../../fonts/Proxima Nova Bold.ttf
// module chunks = 2